import { render, staticRenderFns } from "./PromotionStepReward.vue?vue&type=template&id=3d166661&scoped=true&"
import script from "./PromotionStepReward.vue?vue&type=script&lang=js&"
export * from "./PromotionStepReward.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepReward.vue?vue&type=style&index=0&id=3d166661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d166661",
  null
  
)

export default component.exports